import { Container } from '@plato/ui/containers/container';
import { Join } from '@plato/ui/containers/join';
import { Typography } from '@plato/ui/primitives/typography';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../../utils/api.ts';
import { VisitLoggedItem } from '../../activity-feed-new/components/visit-logged-item.tsx';
import { orderVisitLogged } from '../../activity-feed-new/lib/order-visit-logged.ts';

type Props = {
    noteId: string;
};

/**
 * What was logged on a note — its quotes with their tasks, the other tasks, then the insight
 * outcomes — as the activity feed's cards, one level deeper so they render as bare rows.
 */
export function NoteFollowUpList({ noteId }: Props): ReactNode {
    const { t } = useTranslation('notes');
    const { data } = api.platoUser.query.notes.getFollowUps.useQuery({ noteId });
    const entries = data ? orderVisitLogged(data) : [];

    if (entries.length === 0) {
        return undefined;
    }

    return (
        <section className="flex flex-col gap-cozy">
            <Typography variant="subtle-heading" className="text-content-weaker">
                {t('notes__form__follow_ups_title')}
            </Typography>
            <Container>
                <Join orientation="vertical" className="divide-y divide-line-weakest">
                    {entries.map((entry) => (
                        <VisitLoggedItem key={entry.key} entry={entry} source="note_edit_dialog" />
                    ))}
                </Join>
            </Container>
        </section>
    );
}
